import { PopupPanelVm } from "../../panels/popup-panel-vm";
import { Lazy } from "../lazy";
import { DxOptionFactory } from "../../devexpress/factory/dx-option-factory";
import { Copy } from "../../helper/clipboard-helper";
import { MessageHelper } from "../../helper/message-helper";
import { ControlType } from "../../devexpress/controltype";

export class DebuggingSelectorDialogVm extends PopupPanelVm {
	public static getInstance = Lazy.singleton(DebuggingSelectorDialogVm);

	constructor() {
		super();
		this.applyPopupOptions({
			title: "Selector",
			height: "auto",
			width: 500
		});
	}

	public message: KnockoutObservable<string> = ko.observable(null);

	public copyMessageOptions = new DxOptionFactory().createOptions({
		type: ControlType.Button,
		options: {
			onClick: () => {
				this.copyText();
			}
		}
	});

	public initialize(): void {
	}

	public setSelectorAndShow(message: string) {
		this.message(message);
		this.copyText();
		this.show();
	}

	public copyText() {
		if (Copy.copyTextToClipboard(this.message())) {
			MessageHelper.uiSuccess("Selector copied successful");
		} else {
			MessageHelper.uiError("Error while trying to copy selector");
		}
	}
}